<script>
export const pageName = 'certification-level-3';
export const pageRoute = '/certification/level-3';
export const title = 'Level 3 Certification'
export const requireMembership = true;
export const requireCompleteAccount = true;

import { getMembershipImportDate } from '../../../functions/src/site.config.js'
import CertFlightCardUrl from '../../resources/Cert-and-Record-flight-card-A4-v3-1.pdf'
import { listenToCurrentUserView } from '../../js/readModel.js';
import { PageShowError } from '@trullock/page-manager'

export default {
	data() {
		return {
			currentUser: null,
			CertFlightCardUrl,
			ready: false
		}
	},

	methods: {
		getMembershipImportDate,
		async boot(opts) {
			await listenToCurrentUserView(user => this.currentUser = user);
			this.ready = true;
		},
		show(opts)
		{
			if(this.currentUser.certification.levelNumber < 2)
				throw new PageShowError('/', 'You have not passed L2', {}, 'replace');
		},
		stageBadgeText(stage)
		{
			return stage.status == 'pending' ? 'Pending' : 
				stage.status == 'passed' ? 'Passed' : 
				'Not started'
		},
		stageBadgeClass(stage)
		{
			return stage.status == 'pending' ? 'badge-secondary' : 
				stage.status == 'passed' ? 'badge-success' : 
				'badge-light'
		},
		attemptBadgeText(stage)
		{
			return stage.result == null ? 'Pending' : 
				stage.result == 'passed' ? 'Passed' : 
				'Failed'
		},
		attemptBadgeClass(stage)
		{
			return stage.result == null ? 'badge-secondary' : 
				stage.result == 'passed' ? 'badge-success' : 
				'badge-danger'
		}
	}
}

</script>
<template>
	<div v-if="ready" class="container py-5">
		<div class="row">
			<div class="col col-12">
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Level 3 Certification</h4>
					</div>
					<div class="card-body">
						<p>Level 3 certification is required to fly rockets with motors classified 'M' or above (over 5120Ns), regardless of whether the combined impulse is from a single motor, a cluster of smaller motors or multiple stages. .</p>
						<p>Before beginning the level 3 process, please contact UKRA via <a href="mailto:enquiries@ukra.org.uk">enquiries@ukra.org.uk</a> who will put you in touch with the Safety and Technical Committee to register your interest and provide you with the current guidance documentation.</p>
						<p>Detailed information about the <a href="https://www.ukra.org.uk/certification/high-power-certification/" target="_blank">Level 3 Certification Process <span class="fe fe-external-link"></span></a> can be found on the main UKRA website.</p>
						<p>Download the <a :href="CertFlightCardUrl" target="_blank">Flight Card <span class="fe fe-download"></span></a> for use in the field.</p>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col col-12 col-lg-8">
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Certification Flight</h4>
					</div>
					<div class="card-body" v-if="currentUser.certification.level3.status == 'passed'">
						<p>Congratulations! You've passed your Level 3 certification.</p>
						<p>Why not order a certificate to hang in your rocket workshop?</p>
						<a href="/certification/buy-a-certificate/level3" class="btn btn-primary btn-block">Order a certificate <span class="fe fe-award"></span></a>
					</div>
					<div class="card-body" v-else-if="currentUser.certification.level3.attemptPending">
						<p class="mb-0">Please wait whilst UKRA validates your attempt. You should hear back soon.</p>
					</div>
					<div class="card-body" v-else>
						<p class="mb-0">Add a new rocket/flight in the <a href="/rockets">Flight Logs</a> tool to submit your next certification flight.</p>
					</div>
				</div>
			</div>
			<div class="col col-12 col-lg-4">
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Progress</h4>
					</div>
					<div class="card-body">
						<div class="text-secondary small mb-4">Complete one flight for Level 3.</div>
						<div v-if="currentUser.certification.level3.grantedOn && currentUser.certification.level3.grantedOn < getMembershipImportDate()" class="alert alert-light small mb-4"><span class="fe fe-alert-triangle"></span> You achieved Level 3 by the previous certification process, so your progress will show as incomplete.</div>
						<div v-else-if="currentUser.certification.level3.grantedOn" class="alert alert-light small mb-4"><span class="fe fe-alert-triangle"></span> You were granted Level 3 outside of the normal process, so your certification progress may show as incomplete.</div>
						<div class="list-group list-group-flush my-n3">
							<div class="row">
								<div class="col small">
									Certification Flight
								</div>
								<div class="col-auto">
									<div :class="`badge ${stageBadgeClass(currentUser.certification.level3.stage1)}`">
										{{ stageBadgeText(currentUser.certification.level3.stage1) }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">History</h4>
					</div>
					<div class="card-body">
						<div class="list-group list-group-flush my-n3" v-if="currentUser.certification.level3.stage1.attempts.length">
							<div class="list-group-item" v-for="attempt in currentUser.certification.level3.stage1.attempts.sort((a,b) => a.submittedOn - b.submittedOn)">
								<div class="row">
									<div class="col small">
										<h5>Certification Flight</h5>
										<span class="small text-muted">{{ attempt.submittedOn.format('yyyy/MM/dd HH:mm') }}</span>
									</div>
									<div class="col-auto">
										<div :class="`badge ${attemptBadgeClass(attempt)}`">
											{{ attemptBadgeText(attempt) }}
										</div>
									</div>
								</div>
							</div>
						</div>
						<p class="small text-muted mb-0" v-else>You have not previously submitted any L3 certification attempts.</p>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
